module.exports = __webpack_public_path__ + "static/media/(H)-16_-_bijuterias-acessorios.47d04d44.jpg";